module.exports = __webpack_public_path__ + "img/mali.593dcabf.svg";